import React from "react";
import { useSelector } from "react-redux";
import { deleteUser, logOut } from "../../api/user";
import { useCurrentUser } from "../../custom_hooks/user";
import { CommonForm } from "../common/CommonForm";
import { DeleteUserFormFields } from "../forms/DeleteUserFormFields";

export const DeleteUserDangerZone = () => {
  const currentUser = useCurrentUser();
  const { password } = useSelector((state) => state.appState);

  const triggerDelete = (values) => {
    const { id } = currentUser;
    return new Promise((resolve, reject) => {
      if (values.password !== password) {
        reject({ message: "Wrong password", request: { status: 401 } });
      } else {
        deleteUser(id).then((res) => {
          resolve(res);
          logOut();
        });
      }
    });
  };

  return (
    <div className="alert alert-danger p-4">
      <CommonForm
        translationScope="account_settings.delete_user"
        apiEndpoint={triggerDelete}
        initialValues={{ password: "" }}
        fieldsComponent={DeleteUserFormFields}
      />
    </div>
  );
};
